import { apiRoutes } from '../../../api-routes';
import { publicHttpClient } from '../../../util/http-client';
import type { LoginRequestBody } from '../login-fn';

export interface SendOTPResponse {
  login_method: string;
}

export const sendOTPFn = async (body: LoginRequestBody) => {
  const response = await publicHttpClient.post<SendOTPResponse>(
    apiRoutes.auth.sendOTPLoginV4,
    body,
    {
      withCredentials: true,
    }
  );

  return response.data;
};
